import request from "@/utils/request";


export function getHistory() {

  return request({
    url: "tahsilHamzaman/gethistory",
    method: "post",

  });
}

export function removeTahsilRequest(requestID) {
  return request({
    url: "tahsilHamzaman/remove",
    method: "post",
    data: {
      requestID: requestID,

    },
  });
}

export function saveRequest(file, startDate, endDate, cityID, location, field, is_hozoori, comment) {
  let fileName = file == null ? "" : file.name;
  var fmData = new FormData();

  fmData.append("D_Start", startDate);
  fmData.append("D_End", endDate);
  fmData.append("CityID", parseInt(cityID));
  fmData.append("N_Location", location);
  fmData.append("N_Field", field);
  fmData.append("Is_Hozoori", is_hozoori);
  fmData.append("Comment_Student", comment);
  fmData.append("image", file);
  fmData.append("fileName", fileName);


  return request({
    url: "tahsilHamzaman/save",
    method: "post",
    data: fmData,
  });

}